import React from 'react';

import Checkbox from '../Checkbox';

import styles from './SelectAllCheckbox.module.scss';

interface ISelectAllCheckboxProps {
    checked: boolean,
    onChange: React.ChangeEventHandler<HTMLInputElement>,
}

const SelectAllCheckbox: React.FC<ISelectAllCheckboxProps> = ({checked, onChange}) => (
    <Checkbox
        onChange={onChange}
        checked={checked}
        className={styles.checkbox}
    />
);

export default SelectAllCheckbox;
